import { render, staticRenderFns } from "./declarations.vue?vue&type=template&id=5c8a5fd0&scoped=true&"
import script from "./declarations.vue?vue&type=script&lang=js&"
export * from "./declarations.vue?vue&type=script&lang=js&"
import style0 from "./declarations.vue?vue&type=style&index=0&id=5c8a5fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a5fd0",
  null
  
)

export default component.exports